import React, { Suspense } from 'react';
import { Navigation } from './components/Navigation';

const App = () => {
    return (
        <div className="App">
            <Suspense fallback={<div className='d-flex justify-content-center align-items-center'>{"Loading..."}</div>}>
                <Navigation />
            </Suspense>
        </div>
    );
}

export default App;
